import { render } from "./ImportWizardComponent.vue?vue&type=template&id=493e95e2&scoped=true"
import script from "./ImportWizardComponent.vue?vue&type=script&lang=js"
export * from "./ImportWizardComponent.vue?vue&type=script&lang=js"

import "./ImportWizardComponent.vue?vue&type=style&index=0&id=493e95e2&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493e95e2"]])

export default __exports__